import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import './Imprint.css';

const Imprint: React.FC = () => {
    const { t } = useTranslation();
    const location = useLocation();

    // Scroll to section if hash is provided
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location.hash]);

    return (
        <div className="imprint-container">
            <div className="imprint-content">
                <header className="imprint-header">
                    <h1>{t('imprint.title')}</h1>
                    <p className="last-updated">{t('imprint.lastUpdated')}: {new Date().toLocaleDateString()}</p>
                </header>

                <nav className="imprint-nav">
                    <h3>{t('imprint.tableOfContents')}</h3>
                    <ul>
                        <li><a href="#company-info">{t('imprint.companyInfo')}</a></li>
                        <li><a href="#contact">{t('imprint.contact')}</a></li>
                        <li><a href="#legal-form">{t('imprint.legalForm')}</a></li>
                        <li><a href="#registration">{t('imprint.registration')}</a></li>
                        <li><a href="#responsible-content">{t('imprint.responsibleContent')}</a></li>
                        <li><a href="#disclaimer">{t('imprint.disclaimer')}</a></li>
                    </ul>
                </nav>

                <main className="imprint-main">
                    <section id="company-info" className="imprint-section">
                        <h2>{t('imprint.companyInfo')}</h2>
                        <p><strong>{t('imprint.companyNameLabel')}:</strong> {t('imprint.companyName')}</p>
                        <p><strong>{t('imprint.productNameLabel')}:</strong> LuLarge</p>
                        <p><strong>{t('imprint.address')}:</strong><br />
                           {t('imprint.addressLine1')}<br />
                           {t('imprint.addressLine2')}
                        </p>
                    </section>

                    <section id="contact" className="imprint-section">
                        <h2>{t('imprint.contact')}</h2>
                        <p><strong>{t('imprint.contactPerson')}:</strong> {t('imprint.contactPersonName')}</p>
                        <p><strong>{t('imprint.email')}:</strong> <a href="mailto:info@lularge.com">info@lularge.com</a></p>
                        <p><strong>{t('imprint.phone')}:</strong> {t('imprint.phoneNumber')}</p>
                        <p><strong>{t('imprint.website')}:</strong> <a href="https://www.lularge.com" target="_blank" rel="noopener noreferrer">https://lularge.com</a></p>
                    </section>

                    {/*<section id="legal-form" className="imprint-section">*/}
                    {/*    <h2>{t('imprint.legalForm')}</h2>*/}
                    {/*    <p>{t('imprint.legalFormText')}</p>*/}
                    {/*</section>*/}

                    {/*<section id="registration" className="imprint-section">*/}
                    {/*    <h2>{t('imprint.registration')}</h2>*/}
                    {/*    <p><strong>{t('imprint.registrationNumber')}:</strong> {t('imprint.registrationNumberValue')}</p>*/}
                    {/*    <p><strong>{t('imprint.taxId')}:</strong> {t('imprint.taxIdValue')}</p>*/}
                    {/*</section>*/}

                    {/*<section id="responsible-content" className="imprint-section">*/}
                    {/*    <h2>{t('imprint.responsibleContent')}</h2>*/}
                    {/*    <p>{t('imprint.responsibleContentText')}</p>*/}
                    {/*    <p><strong>{t('imprint.responsiblePerson')}:</strong> {t('imprint.responsiblePersonName')}</p>*/}
                    {/*</section>*/}

                    <section id="disclaimer" className="imprint-section">
                        <h2>{t('imprint.disclaimer')}</h2>
                        <p>{t('imprint.disclaimerText')}</p>
                        
                        <h3>{t('imprint.disclaimerLiability')}</h3>
                        <p>{t('imprint.disclaimerLiabilityText')}</p>
                        
                        <h3>{t('imprint.disclaimerLinks')}</h3>
                        <p>{t('imprint.disclaimerLinksText')}</p>
                        
                        <h3>{t('imprint.disclaimerCopyright')}</h3>
                        <p>{t('imprint.disclaimerCopyrightText')}</p>
                    </section>
                </main>

                <footer className="imprint-footer">
                    <p>{t('imprint.footerText')}</p>
                    <div>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default Imprint;